import MainImageCardDashboard2 from "../../../components/Cards/MainImageCardDashboard2";
import HeaderCardSmall from "../../../components/Header/HeaderCardSmall";
import { microbiome } from "../../../constants";
import DiaOverview from "./MicrobiotaAux/DiaOverview";
import ToArchive from "../Genomics/GenomicsAux/ToArchive";


export default function MicrobiotaCard() {



return (
<>

    <MainImageCardDashboard2

        content = {<HeaderCardSmall cardheadline={'Microbiome 360'} /> }

        iconbuttons = {<> 
                <DiaOverview /> 
                <ToArchive />             
                 </>}  

        photo = { microbiome }  

    />

</>
)};
